import React, {useState, useEffect} from 'react';
import { useStyles } from "./style";
import {Grid, Typography, Paper} from '@material-ui/core/';
import Title from 'components/TitleWithIcon';
import { AccountCircle, Wc, Today, Room, Person, Payment, AssignmentInd, Phone } from '@material-ui/icons/';
import { functions } from 'constants/functions';

function DatosBasicosDelFallecido(props) {
    const classes = useStyles()
    let nombreCompleto = (
        (props.datosPadron?.primerNombre ? (props.datosPadron?.primerNombre+' ') : '')+
        (props.datosPadron?.segundoNombre ? (props.datosPadron?.segundoNombre) : '')+
        (props.datosPadron?.primerApellido ? (' , '+props.datosPadron?.primerApellido+' ') : '')+
        (props.datosPadron?.segundoApellido ? (props.datosPadron?.segundoApellido+' ') : '')+
        (props.datosPadron?.tercerApellido ? props.datosPadron?.tercerApellido : '')
    )
    let nombreCompletoPadre = (
        (props.datosPadron?.complemento?.primerNomPadre ? (props.datosPadron?.complemento?.primerNomPadre+' ') : '')+
        (props.datosPadron?.complemento?.segundoNomPadre ? (props.datosPadron?.complemento?.segundoNomPadre) : '')+
        (props.datosPadron?.complemento?.primerApePadre ? (' , '+props.datosPadron?.complemento?.primerApePadre+' ') : '')+
        (props.datosPadron?.complemento?.segundoApePadre ? (props.datosPadron?.complemento?.segundoApePadre+' ') : '')
    )
    let nombreCompletoMadre = (
        (props.datosPadron?.complemento?.primerNomMadre ? (props.datosPadron?.complemento?.primerNomMadre+' ') : '')+
        (props.datosPadron?.complemento?.segundoNomMadre ? (props.datosPadron?.complemento?.segundoNomMadre) : '')+
        (props.datosPadron?.complemento?.primerApeMadre ? (' , '+props.datosPadron?.complemento?.primerApeMadre+' ') : '')+
        (props.datosPadron?.complemento?.segundoApeMadre ? (props.datosPadron?.complemento?.segundoApeMadre+' ') : '')
    )
    let lugarNacimiento = (
        (props.datosPadron?.departamentoNacimientoPadron?.nameShort ? (props.datosPadron?.departamentoNacimientoPadron?.nameShort+' , ') : '')+
        (props.datosPadron?.municipioNacimientoPadron?.municipio ? (props.datosPadron?.municipioNacimientoPadron?.municipio) : '')
        )
    let lugarVecindad = (
        (props.datosPadron?.dpi?.departamentoVecindad?.nameShort ? (props.datosPadron?.dpi?.departamentoVecindad?.nameShort+' , ') : '')+
        (props.datosPadron?.dpi?.municipioVecindad?.municipio ? (props.datosPadron?.dpi?.municipioVecindad?.municipio) : '')
        )
    let lugarResidencia = (
        (props.datosPadron?.departamentoResidenciaPadron?.nameShort ? (props.datosPadron?.departamentoResidenciaPadron?.nameShort+' , ') : '')+
        (props.datosPadron?.municipioResidenciaPadron?.municipio ? (props.datosPadron?.municipioResidenciaPadron?.municipio) : '')
        )
    let estadoPadron = (
        (props.datosPadron?.estadoPadron?.codStatus ? (props.datosPadron?.estadoPadron?.codStatus+'. ') : '')+
        (props.datosPadron?.estadoPadron?.nombreStatus ? (props.datosPadron?.estadoPadron?.nombreStatus) : '')
    )
    let cedula = (
        (props.datosPadron?.dpi?.ordenCedulaRef ? (props.datosPadron?.dpi?.ordenCedulaRef+' ') : '')+
        (props.datosPadron?.dpi?.registroCedulaRef ? (props.datosPadron?.dpi?.registroCedulaRef) : '')
    )
    let direccionResidencia = (
        (props.datosPadron?.direccion ? (props.datosPadron?.direccion) : '')+
        (props.datosPadron?.numeroCasa ? (', '+props.datosPadron?.numeroCasa) : '')+
        (props.datosPadron?.numeroZona ? (', zona '+props.datosPadron?.numeroZona) : '')
    )
    const datosFallecido = [
        {icon: <Payment style={{ fontSize: 40, color: '#205690' }}/>, title: 'CUI del DPI', value: props.datosPadron?.dpi?.cui},
        {icon: <Payment style={{ fontSize: 40, color: '#205690' }}/>, title: 'Número de boleta', value: props.datosPadron?.dpi?.nroboleta},
        {icon: <AccountCircle style={{ fontSize: 40, color: '#205690' }}/>, title: 'Nombre completo', value: nombreCompleto},
        {icon: <AssignmentInd style={{ fontSize: 40, color: '#205690' }}/>, title: 'Estado en el Padrón', value: estadoPadron},
        {icon: <Payment style={{ fontSize: 40, color: '#205690' }}/>, title: 'Número de cédula', value: cedula},
        {icon: <Wc style={{ fontSize: 40, color: '#205690' }}/>, title: 'Género', value: (
            (props.datosPadron?.genero === 1) ? 'Masculino' :
            (props.datosPadron?.genero === 0) ? 'Femenino' : ''
        )},
        {icon: <Room style={{ fontSize: 40, color: '#205690' }}/>, title: 'Lugar de residencia', value: lugarResidencia},
        {icon: <Room style={{ fontSize: 40, color: '#205690' }}/>, title: 'Dirección de residencia', value: direccionResidencia},
        {icon: <Phone style={{ fontSize: 40, color: '#205690' }}/>, title: 'Teléfono', value: props.datosPadron?.complemento?.telefono},
        {icon: <Today style={{ fontSize: 40, color: '#205690' }}/>, title: 'Fecha de nacimiento', value: functions.dateFormatGeneral(props.datosPadron?.fechaNacimiento)},
        {icon: <Room style={{ fontSize: 40, color: '#205690' }}/>, title: 'Lugar de nacimiento', value: lugarNacimiento},
        {icon: <Room style={{ fontSize: 40, color: '#205690' }}/>, title: 'Lugar de vecindad', value: lugarVecindad},
        {icon: <Person style={{ fontSize: 40, color: '#205690' }}/>, title: 'Nombre del padre', value: nombreCompletoPadre},
        {icon: <Person style={{ fontSize: 40, color: '#205690' }}/>, title: 'Nombre de la madre', value: nombreCompletoMadre},
    ]

    return (
        <div className={classes.colorComponente}>
            <div className={classes.root}>
                <Title title="INFORMACIÓN" icon={""}/>
                <Grid container className={classes.gridContainer}>
                    {
                        datosFallecido.map((label, index) => (
                            <Grid item xs={4} className={classes.grid}>
                                <Paper className={classes.paper} elevation={0}>
                                    <Grid item xs={12} sm container direction="row" justifyContent="flex-start" alignItems="center">
                                        <Grid item xs={2} className={classes.icon}>
                                            {label.icon}
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1" className={classes.TypographyTitle}>
                                                {label.title}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="subtitle1" className={classes.TypographyBody}>
                                                {label.value}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>                                                
                        ))
                    }
                </Grid><br/>
                <div className={classes.lineaDegradadaBottom}></div>
            </div>
        </div>
    );
}


export default DatosBasicosDelFallecido;